const {store, AoflElement, clickTrackerMixin} = aofljs;
import './sdo';
/**
 * @summary HomeFooter
 * @class HomeFooter
 * @extends {clickTrackerMixin(AoflElement)}
 */
class HomeFooter extends clickTrackerMixin(AoflElement) {
  /**
   * Creates an instance of HomeHeader.
   * @memberof HomeHeader
   */
  constructor() {
    super(store);
    this.unsubscribeStore = store.subscribe(() => {
      this.mapProperties();
    });
    this.mapProperties();
  }

  /**
   *
   * @readonly
   * @static
   * @memberof HomeFooter
   */
  static get is() {
    return 'home-footer';
  }

  /**
   *
   * @memberof HomeFooter
   */
  connectedCallback() {
    super.connectedCallback();
  }

  /**
   *
   * @memberof HomeFooter
   */
  disconnectedCallback() {
    super.disconnectedCallback();
    this.unsubscribeStore();
  }

  /**
   *
   * @memberof HomeFooter
   */
  mapProperties() {
    let state = store.getState().homeFooter;
    this.showAbout = state.showAbout;
    this.showPopular = state.showPopular;
    this.showMore = state.showMore;
  }

  /**
   *
   * @param {Object} e The standard event object
   * @memberof HomeFooter
   */
  navAbout(e) {
    store.commit([
      {
        stateAlias: 'homeFooter',
        mutationId: 'toggleAbout'
      }
    ]);
  }

  /**
   *
   * @param {Object} e The standard event object
   * @memberof HomeFooter
   */
  navPopular(e) {
    store.commit([
      {
        stateAlias: 'homeFooter',
        mutationId: 'togglePopular'
      }
    ]);
  }

  /**
   *
   * @param {Object} e The standard event object
   * @memberof HomeFooter
   */
  navMore(e) {
    store.commit([
      {
        stateAlias: 'homeFooter',
        mutationId: 'toggleMore'
      }
    ]);
  }
}

window.customElements.define(HomeFooter.is, HomeFooter);



// WEBPACK FOOTER //
// ./home/en-US/js/home-footer/home-footer.js